import { Command as CommandPrimitive } from 'cmdk'
import type React from 'react'
import { cn } from '@/src/utils/styles'

export const List = ({
  className,
  disableScroll = false,
  ...props
}: React.ComponentPropsWithoutRef<typeof CommandPrimitive.List> & {
  disableScroll?: boolean
}) => (
  <CommandPrimitive.List
    className={cn(
      'relative w-full flex-grow sm:min-h-[32rem] sm:h-[32rem] sm:p-1 sm:grow-0 pb-16',
      disableScroll
        ? 'overflow-hidden'
        : 'no-scrollbar overflow-y-auto overflow-x-hidden',
      className,
    )}
    onMouseDown={(e) => {
      e.stopPropagation()
      e.preventDefault()
    }}
    {...props}
  />
)
